export interface IHop {
  NoHops?: number        // 627
  HopCompID?: string// 628
  HopSendingTime?: Date// 629
  HopRefID?: number// 630
}
